import { type ISpot, SPOT_STATUSES_RESERVED, SpotEventTypeEnum, SpotStatus } from './yard';

export const SPOT_STATUSES_BLOCKED_FOR_NEW_ASSIGNMENT: readonly SpotStatus[] = Object.freeze([
  SpotStatus.CLOSED,
  SpotStatus.RESERVED_MANUAL,
  SpotStatus.RESERVED_AUTOMATED
]) as readonly SpotStatus[];

export function canSpotAcceptNewAssignment(spot: Pick<ISpot, 'status'>): boolean {
  return !SPOT_STATUSES_BLOCKED_FOR_NEW_ASSIGNMENT.includes(spot.status ?? SpotStatus.UNKNOWN);
}

export type SpotStatusChangeRules = Record<SpotStatus, SpotStatus[]>;

export function getSpotStatusChangeRules(): SpotStatusChangeRules {
  return {
    [SpotStatus.OPEN]: [
      SpotStatus.CLOSED,
      SpotStatus.ASSIGNED,
      SpotStatus.RESERVED_MANUAL,
      SpotStatus.RESERVED_AUTOMATED
    ],
    [SpotStatus.CLOSED]: [SpotStatus.OPEN, SpotStatus.ASSIGNED],
    [SpotStatus.ASSIGNED]: [SpotStatus.OPEN, SpotStatus.CLOSED],
    [SpotStatus.RESERVED_MANUAL]: [SpotStatus.OPEN, SpotStatus.ASSIGNED],
    [SpotStatus.RESERVED_AUTOMATED]: [SpotStatus.OPEN, SpotStatus.ASSIGNED],
    [SpotStatus.UNKNOWN]: [
      SpotStatus.OPEN,
      SpotStatus.CLOSED,
      SpotStatus.ASSIGNED,
      SpotStatus.RESERVED_MANUAL,
      SpotStatus.RESERVED_AUTOMATED
    ]
  };
}

export function isSpotStatusTransitionAllowed(from: SpotStatus, to: SpotStatus): boolean {
  if (from === to) {
    return true;
  }
  return getSpotStatusChangeRules()[from]?.includes(to) ?? false;
}

export function getSpotTransitionEvent(from: SpotStatus, to: SpotStatus): SpotEventTypeEnum {
  switch (to) {
    case SpotStatus.CLOSED:
      return SpotEventTypeEnum.CLOSE;
    case SpotStatus.RESERVED_MANUAL:
    case SpotStatus.RESERVED_AUTOMATED:
      return SpotEventTypeEnum.RESERVE;
    case SpotStatus.ASSIGNED:
      return SpotEventTypeEnum.ASSIGNMENT;
    case SpotStatus.OPEN:
      if (SPOT_STATUSES_RESERVED.includes(from)) {
        return SpotEventTypeEnum.RELEASE_RESERVE;
      }
      if (from === SpotStatus.ASSIGNED) {
        return SpotEventTypeEnum.RELEASE;
      }
      return SpotEventTypeEnum.OPEN;
    default:
      return SpotEventTypeEnum.OTHER;
  }
}
